import { config } from "./config.js";
import { features } from "./features.js";
import Model from "./Model.js";
import AcademyController from "./AcademyController.js";

// Todo: Remove configuration form global context
window.config = config;

const model = new Model(
	config.locations,
	config.countries,
	config.continents,
	config.pluses,
	config.intro,
	config.categories,
	config.engines,
	config.cart,
	config.navigation,
	config.finderDefaultImage,
);

document.addEventListener("alpine:init", () => {
	Alpine.store("controller", new AcademyController(model, config, features));
});
